module.exports = __webpack_public_path__ + "static/media/profilePicturePlaceholder.d13b0919.png";